const constants = {
    knowledgeBase: 'https://support.propertyboss.com/support/home',
    requestSupport: "https://www.propertyboss.net/ClientCentral3.0/helpdesk/help-requests/?helpdeskform",
    propertyHostClientForWindow: 'https://online.propertyboss.net/downloads/setup.exe',
    forgotPasswordUrl: 'https://propertyhost.propertyboss.net/PropertyHost/',
    portalUrl : process.env.REACT_APP_PORTAL_URL,
};
export default constants;